<template>
  <div class="product-card-product-page" :data-productKey="code">
    <div class="product-card-product-page__info-wrap">
      <ProductPhoto
        :product-id="id"
        :title="title"
        :image-url="imageUrl"
        :second-image-url="secondImageUrl"
        class="product-card-product-page__photo"
      />
      <div class="product-card-product-page__info">
        <ProductTitle :title="title" />
        <div class="product-card-product-page__reviews-wrap">
          <div class="product-card-product-page__reviews">
            <StarRating
              v-if="rating"
              :value="Math.round(rating)"
              :disabled="true"
              class="product-card-product-page__rating"
              :title="Number(rating).toFixed(1)"
            />
            <ReviewsCounter :value="reviewsCount" is-product-page />
          </div>
          <ProductCode :code="code" class="product-card-product-page__code" is-adaptive />
        </div>
        <ProductPrice
          v-if="showProductPrice"
          :price="getNewPrice"
          :old-price="getOldPrice"
          class="product-card-product-page__price"
        />
        <span
          v-else-if="!isPreorder"
          class="product-card-product-page__price product-card-product-page__price--not-available"
        >{{ $t('out_of_stock') }}</span
        >
      </div>
    </div>
    <div class="product-card-product-page__button-wrap">
      <div class="product-card-product-page__buy-btn-wrap" v-if="(isAvailable || availableInStore) && !isPreorder">
        <BuyBtn
          v-if="inStock || availableInStore"
          :title-analytics="titleAnalytics"
          :product-id="id"
          :code="code"
          :price="this.priceObject.price_new"
          :store-id="availableInStore ? availableInStore.store_id : ''"
          size="medium"
          product-page
          small-card
          class="product-card-product-page__buy-btn"
          :class="{ 'product-card-product-page__buy-btn--available-in-store': availableInStore }"
        />
        <BuyBtn
          v-if="!isManager && !availableInStore && config.isEnabledOneClickAndCallback"
          type="invert"
          size="medium"
          :product-id="id"
          one-click-btn
          product-page
          small-card
          class="product-card-product-page__one-click-btn"
        />
        <a v-if="allegroLink"
           @click="handleAllegroRedirect($event, allegroLink)"
           :href="allegroLink"
           target="_blank"
           class="allegro-btn">
          {{ $t('allegro.buy-btn') }}
          <svg width="50"
               height="22"
               viewBox="0 0 50 22"
               fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M47.9131 8.90175C48.0515 9.10823 48.1741 9.32567 48.2802 9.5522C48.386 9.77842 48.4747 10.0134 48.5458 10.2544C48.6165 10.495 48.6692 10.7416 48.7034 10.991C48.7376 11.2404 48.7529 11.4923 48.7496 11.7442C48.7529 11.9964 48.7376 12.2483 48.7034 12.4977C48.6692 12.7471 48.6165 12.9937 48.5458 13.2344C48.4747 13.4753 48.386 13.71 48.2802 13.9365C48.1741 14.163 48.0515 14.3805 47.9131 14.5866C47.4968 15.1475 46.9633 15.6015 46.353 15.9136C45.7431 16.2256 45.073 16.3879 44.3938 16.3879C43.7146 16.3879 43.0445 16.2256 42.4346 15.9136C41.8243 15.6015 41.2908 15.1475 40.8745 14.5866C40.7361 14.3805 40.6135 14.163 40.5074 13.9365C40.4016 13.7103 40.3126 13.4753 40.2418 13.2347C40.1708 12.9937 40.1181 12.7471 40.0839 12.4977C40.05 12.2483 40.0344 11.9964 40.038 11.7442C40.0344 11.4923 40.05 11.2404 40.0839 10.991C40.1181 10.7413 40.1708 10.495 40.2418 10.254C40.3126 10.0131 40.4016 9.77842 40.5074 9.5522C40.6135 9.32567 40.7361 9.10823 40.8745 8.90175C41.2908 8.34122 41.8243 7.88722 42.4346 7.57515C43.0445 7.26308 43.7146 7.10078 44.3938 7.10078C45.073 7.10078 45.7431 7.26308 46.353 7.57515C46.9633 7.88722 47.4968 8.34122 47.9131 8.90175ZM46.5191 12.8067C46.5748 12.6356 46.6171 12.4601 46.6453 12.2819C46.6734 12.1036 46.6878 11.9231 46.6878 11.7426C46.6878 11.5618 46.6734 11.3814 46.6453 11.2031C46.6171 11.0251 46.5748 10.8494 46.5191 10.6783C46.1993 9.68004 45.4377 8.85225 44.3905 8.877C43.343 8.90175 42.585 9.68004 42.2652 10.6783C42.2092 10.8497 42.1666 11.0254 42.1384 11.204C42.11 11.3826 42.0956 11.5634 42.0956 11.7442C42.0956 11.9253 42.11 12.1061 42.1384 12.2847C42.1666 12.4633 42.2092 12.639 42.2652 12.8101C42.5814 13.8087 43.3397 14.6365 44.3905 14.6117C45.441 14.5866 46.1993 13.8087 46.5191 12.8101V12.8067ZM14.472 16.1501C14.472 16.1846 14.4654 16.2187 14.4528 16.2507C14.4399 16.2826 14.4216 16.3118 14.3983 16.3359C14.3749 16.3604 14.347 16.3798 14.3164 16.3929C14.2859 16.4064 14.2532 16.413 14.2202 16.413H12.7582C12.725 16.413 12.6923 16.4064 12.6617 16.3929C12.6314 16.3798 12.6036 16.3604 12.5802 16.3359C12.5568 16.3118 12.5382 16.2826 12.5256 16.2507C12.5131 16.2187 12.5065 16.1846 12.5065 16.1501V3.59002C12.5065 3.55556 12.5131 3.52141 12.5256 3.48945C12.5382 3.45749 12.5568 3.42866 12.5802 3.40423C12.6036 3.37979 12.6314 3.36036 12.6617 3.3472C12.6923 3.33404 12.725 3.32715 12.7582 3.32715H14.2202C14.2532 3.32715 14.2859 3.33404 14.3164 3.3472C14.347 3.36036 14.3749 3.37979 14.3983 3.40423C14.4216 3.42866 14.4399 3.45749 14.4528 3.48945C14.4654 3.52141 14.472 3.55556 14.472 3.59002V16.1501ZM11.0376 16.1501C11.0376 16.1846 11.0313 16.2187 11.0184 16.2507C11.0058 16.2826 10.9872 16.3118 10.9638 16.3359C10.9404 16.3604 10.9129 16.3798 10.8823 16.3929C10.8517 16.4064 10.8191 16.413 10.7861 16.413H9.32378C9.29081 16.413 9.25815 16.4064 9.22757 16.3929C9.197 16.3798 9.16943 16.3604 9.14605 16.3359C9.12267 16.3118 9.10409 16.2826 9.0915 16.2507C9.07892 16.2187 9.07232 16.1846 9.07232 16.1501V3.59002C9.07232 3.55587 9.07862 3.52203 9.0912 3.49039C9.10349 3.45874 9.12178 3.42992 9.14485 3.40548C9.16793 3.38104 9.19521 3.36161 9.22518 3.34814C9.25545 3.33467 9.28782 3.32746 9.32049 3.32715H10.7825C10.8158 3.32715 10.8484 3.33404 10.879 3.3472C10.9096 3.36036 10.9372 3.37979 10.9605 3.40423C10.9839 3.42866 11.0025 3.45749 11.0151 3.48945C11.0277 3.52141 11.0343 3.55556 11.0343 3.59002V16.1501H11.0376ZM39.7083 8.68869C39.7143 8.73475 39.7089 8.78144 39.6931 8.82499C39.6772 8.86823 39.6511 8.90676 39.6172 8.93684C39.5834 8.96692 39.5429 8.9876 39.4994 8.997C39.456 9.0064 39.4107 9.00421 39.3682 8.99073C37.7158 8.63543 36.6992 9.40275 36.6992 10.9982V16.1501C36.6992 16.1846 36.6926 16.2187 36.68 16.2507C36.6674 16.2826 36.6488 16.3118 36.6255 16.3359C36.6021 16.3604 36.5742 16.3798 36.5436 16.3929C36.5134 16.4064 36.4804 16.413 36.4474 16.413H34.9854C34.9525 16.413 34.9195 16.4064 34.8892 16.3929C34.8586 16.3798 34.8308 16.3604 34.8074 16.3359C34.784 16.3118 34.7654 16.2826 34.7528 16.2507C34.7403 16.2187 34.7337 16.1846 34.7337 16.1501V10.8882C34.7295 10.6397 34.7499 10.3919 34.7951 10.1481C34.8401 9.90438 34.9096 9.66625 35.0022 9.43784C35.0948 9.20912 35.2099 8.99136 35.346 8.7877C35.4821 8.58436 35.6382 8.39636 35.8117 8.22686C35.9883 8.04639 36.1813 7.8844 36.3878 7.7434C36.5946 7.6021 36.814 7.48241 37.0427 7.38559C37.2717 7.28909 37.509 7.21577 37.7518 7.16752C37.9943 7.11896 38.2406 7.09546 38.4876 7.09702C38.573 7.09734 38.6584 7.09953 38.7439 7.1036C38.8293 7.10799 38.9147 7.11426 38.9998 7.12272C39.0849 7.13086 39.1698 7.1412 39.2546 7.15342C39.3391 7.16595 39.4236 7.18005 39.5075 7.19635C39.6811 7.25682 39.7083 7.36335 39.7083 7.63688V8.68869ZM33.4452 11.7407V16.1501C33.4476 16.3068 33.4443 16.4634 33.4353 16.6198C33.4263 16.7758 33.4119 16.9318 33.3915 17.0869C33.3715 17.2423 33.3457 17.3965 33.3142 17.5497C33.2827 17.7026 33.2459 17.8546 33.2036 18.005C33.1476 18.1977 33.0744 18.3847 32.9851 18.5636C32.8958 18.7425 32.7909 18.9123 32.6716 19.0709C32.5523 19.2294 32.4193 19.3761 32.2742 19.5089C32.1288 19.6418 31.9724 19.7605 31.806 19.863C30.8473 20.4351 29.5723 20.4705 27.6784 20.3C27.6493 20.3016 27.6202 20.2969 27.5929 20.2866C27.5657 20.2762 27.5405 20.2606 27.5189 20.2402C27.4976 20.2195 27.4799 20.1948 27.4677 20.1675C27.4554 20.1399 27.4485 20.1102 27.447 20.0798V18.7297C27.447 18.4775 27.6034 18.4417 27.8279 18.4775C27.967 18.4981 28.1064 18.5157 28.246 18.5301C28.3857 18.5445 28.5257 18.5558 28.6656 18.5639C28.8059 18.5718 28.9462 18.5768 29.0867 18.5783C29.227 18.5799 29.3673 18.578 29.5075 18.5733C30.3237 18.5201 31.5986 18.2428 31.5986 16.7185V15.5958C31.4146 15.7243 31.2216 15.8384 31.0214 15.9371C30.8209 16.0354 30.6141 16.1185 30.4019 16.1852C30.19 16.2519 29.9736 16.3024 29.7545 16.3356C29.5354 16.3691 29.3142 16.3854 29.0927 16.3848C28.7534 16.3898 28.4151 16.3531 28.0839 16.2754C27.7527 16.1977 27.4317 16.0799 27.1269 15.9239C26.8224 15.7679 26.5361 15.5752 26.2745 15.3493C26.0128 15.1237 25.7776 14.8664 25.5735 14.5832C25.2989 14.168 25.0858 13.7115 24.942 13.2297C24.7981 12.7474 24.725 12.2455 24.725 11.7407C24.725 11.236 24.7981 10.7341 24.942 10.2522C25.0858 9.76996 25.2989 9.31377 25.5735 8.8983C25.9901 8.33746 26.5236 7.88377 27.1335 7.5717C27.7434 7.25932 28.4136 7.09702 29.0927 7.09702C29.7719 7.09702 30.4423 7.25932 31.0523 7.5717C31.6622 7.88377 32.1957 8.33746 32.612 8.8983C32.7513 9.10416 32.8748 9.32129 32.9815 9.5475C33.0879 9.77372 33.1769 10.0087 33.248 10.2497C33.3187 10.4906 33.3715 10.7372 33.405 10.9869C33.4386 11.2366 33.453 11.4885 33.4485 11.7407H33.4452ZM31.5204 11.7373C31.5204 11.3748 31.4425 8.86979 29.0927 8.86979C28.0422 8.86979 27.2839 9.67283 26.9641 10.6714C26.9081 10.8425 26.8658 11.0185 26.8374 11.1968C26.8089 11.3754 26.7945 11.5562 26.7945 11.7373C26.7945 11.9184 26.8089 12.0989 26.8374 12.2775C26.8658 12.4561 26.9081 12.6318 26.9641 12.8032C27.2839 13.8015 28.0422 14.6045 29.0927 14.6045C31.4425 14.6045 31.5204 12.0995 31.5204 11.7373ZM7.73589 10.8099V16.1395C7.73589 16.1739 7.7296 16.2081 7.71701 16.24C7.70412 16.272 7.68554 16.3008 7.66246 16.3253C7.63908 16.3497 7.61121 16.3691 7.58064 16.3823C7.55007 16.3954 7.5174 16.4023 7.48443 16.4023H3.18321C2.9827 16.4142 2.78159 16.4086 2.58228 16.3854C2.38267 16.3622 2.18546 16.3215 1.99244 16.2638C1.79942 16.2062 1.6115 16.1316 1.43048 16.0414C1.24945 15.9508 1.07591 15.8446 0.911668 15.7237C0.760611 15.594 0.62484 15.4464 0.506752 15.2835C0.388664 15.1209 0.289158 14.9441 0.210633 14.7571C0.132107 14.57 0.0748618 14.3739 0.0400948 14.1731C0.00502809 13.9719 -0.00696053 13.7673 0.00382923 13.5636V13.5351C0.00382923 10.8453 2.80557 10.49 3.7203 10.49H5.84558V10.2948C5.85008 10.1663 5.83779 10.0375 5.80902 9.91252C5.78025 9.78751 5.73559 9.66719 5.67595 9.55471C5.6163 9.44223 5.54227 9.33852 5.45625 9.24703C5.36994 9.15523 5.27193 9.07627 5.16553 9.01204C4.38687 8.60002 2.85682 8.75261 1.58153 9.57351C1.55126 9.60108 1.5141 9.61988 1.47453 9.62771C1.43497 9.63555 1.39391 9.63241 1.35585 9.61832C1.31778 9.60422 1.28391 9.57978 1.25784 9.5475C1.23206 9.51523 1.21468 9.47638 1.20749 9.43471L1.12926 8.09902C1.12926 8.08179 1.13106 8.06487 1.13526 8.04827C1.13915 8.03166 1.14545 8.01568 1.15354 8.00064C1.16133 7.98591 1.17122 7.97213 1.18261 7.95991C1.1943 7.94769 1.20719 7.93704 1.22127 7.92826C1.44606 7.7926 1.67924 7.67228 1.91901 7.56857C2.15908 7.46486 2.40515 7.37776 2.65601 7.30789C2.90717 7.23802 3.16223 7.18569 3.41969 7.15091C3.67714 7.11645 3.9367 7.09953 4.19625 7.10047C5.23686 7.10047 6.359 7.41661 6.91647 8.05265C7.47424 8.68869 7.73259 9.60892 7.73259 10.8205L7.73589 10.8099ZM5.84558 12.1174H3.83599C2.28886 12.1174 1.97955 13.0767 1.97955 13.5564C1.97806 13.6417 1.98645 13.7266 2.00473 13.8096C2.02301 13.8926 2.05089 13.9728 2.08775 14.0487C2.12462 14.1248 2.17017 14.1956 2.22382 14.2598C2.27717 14.3244 2.33771 14.3814 2.40455 14.4303C2.46899 14.4814 2.53732 14.5271 2.60866 14.5669C2.67999 14.6067 2.75402 14.6408 2.83045 14.669C2.90657 14.6969 2.9851 14.7189 3.06452 14.7342C3.14395 14.7496 3.22457 14.7583 3.3055 14.7608H5.84558V12.1174ZM19.8543 7.10047C23.4077 7.10047 23.8666 10.5718 23.7647 12.2239C23.7641 12.2565 23.7578 12.2884 23.7455 12.3182C23.7335 12.348 23.7158 12.3749 23.6936 12.3975C23.6718 12.4203 23.6457 12.4382 23.6169 12.4504C23.5881 12.463 23.5576 12.4692 23.5267 12.4692H17.7464C17.7767 12.7603 17.8576 13.0432 17.9847 13.3045C18.112 13.5655 18.2835 13.8002 18.4909 13.9973C18.6983 14.1941 18.9384 14.3501 19.1991 14.4576C19.4599 14.565 19.7374 14.622 20.0176 14.6258C20.2637 14.6512 20.5113 14.6549 20.7576 14.6371C21.0043 14.6195 21.2492 14.5801 21.4895 14.5196C21.7296 14.4594 21.9649 14.3783 22.1924 14.2768C22.4196 14.1756 22.6383 14.0546 22.8466 13.9152C23.0472 13.7695 23.1865 13.8832 23.1865 14.1248V15.3079C23.1967 15.3499 23.2006 15.3931 23.1979 15.4364C23.1952 15.4796 23.1862 15.5219 23.1712 15.5623C23.156 15.6024 23.135 15.64 23.1086 15.6736C23.0825 15.7068 23.0514 15.7359 23.0166 15.7594C22.2991 16.1855 21.3607 16.4343 19.9565 16.381C19.6181 16.3807 19.2806 16.34 18.9509 16.2601C18.6213 16.1799 18.3015 16.0611 17.9975 15.9054C17.6936 15.75 17.4077 15.5586 17.1449 15.3355C16.8823 15.1124 16.6449 14.8589 16.4372 14.5797C16.2988 14.3733 16.1762 14.1558 16.0701 13.9293C15.9643 13.7031 15.8753 13.4684 15.8045 13.2275C15.7335 12.9865 15.6807 12.7402 15.6469 12.4905C15.6127 12.2411 15.5971 11.9892 15.6007 11.7373C15.6004 11.6301 15.6034 11.523 15.6097 11.4162C15.616 11.3093 15.6253 11.2028 15.6379 11.0962C15.6502 10.99 15.6658 10.8841 15.6846 10.7789C15.7035 10.6736 15.7254 10.5692 15.7503 10.4652C16.1141 8.92306 17.2534 7.10047 19.8543 7.10047ZM21.7074 10.8346C21.726 10.5749 21.6909 10.3139 21.6049 10.0692C21.5186 9.82479 21.3834 9.60234 21.2084 9.41685C21.0331 9.23136 20.8218 9.08724 20.5889 8.99418C20.356 8.90112 20.1066 8.86102 19.8579 8.877C19.5977 8.86071 19.337 8.89862 19.0912 8.98854C18.8451 9.07846 18.6189 9.21852 18.4252 9.40087C18.2316 9.58291 18.0746 9.80349 17.9631 10.0498C17.8519 10.296 17.7886 10.5627 17.777 10.8346H21.7074Z"
                  fill="#FF5A00"/>
          </svg>
        </a>
      </div>
      <!--      <BuyBtn-->
      <!--        v-else-if="isNovelty"-->
      <!--        pre-order-btn-->
      <!--        :title-ru="titleRu"-->
      <!--        :product-id="id"-->
      <!--        :code="code"-->
      <!--        :price="this.priceObject.price_new"-->
      <!--        size="medium"-->
      <!--        small-card-->
      <!--        product-page-->
      <!--        class="product-card-product-page__buy-btn"-->
      <!--        :class="{ 'product-card-product-page__buy-btn&#45;&#45;novelty': isNovelty }"-->
      <!--      />-->
      <BuyBtn
        v-else-if="isPreorder && !isArchive"
        pre-order-btn
        :title-analytics="titleAnalytics"
        :product-id="id"
        :code="code"
        :price="this.priceObject.price_new"
        size="medium"
        small-card
        product-page
        class="product-card-product-page__buy-btn"
        :class="{ 'product-card-product-page__buy-btn--novelty': isPreorder }"
      />
      <WaitListBtn
        v-else
        :in-wait-list-status="isInWaitList"
        :title-analytics="titleAnalytics"
        :product-id="id"
        is-small-card
        small-card
        product-page
        class="wait-list--card"
      />
      <AddToComparisonBtn
        :product-id="id"
        :title-analytics="titleAnalytics"
        product-page
        class="product-card-product-page__add-to-comparison"
      />
      <WishListBtn
        class="product-card-product-page__wish-list-btn"
        :id="id"
        :analytics-data="analyticsData"
        :code="code"
        :in-wish-list-status="isInWishList"
        product-page
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ProductPhoto from '../ProductPhoto'
import ProductTitle from '../ProductTitle'
import ProductCode from '../ProductCode'
import ProductPrice from '../ProductPrice'
import StarRating from '../StarRating'
import ReviewsCounter from '../ReviewsCounter'
import BuyBtn from '../../cart/BuyBtn'
import WaitListBtn from '../product-page/WaitListBtn'
import AddToComparisonBtn from '../product-comparison/AddToComparisonBtn'
import WishListBtn from '../WishListBtn'
import { GoogleEnhancedEcommerce } from '@/services/AnalyticService'

export default {
  name: 'ProductCardProductPage',
  components: {
    ProductTitle,
    ProductPhoto,
    ProductCode,
    ProductPrice,
    StarRating,
    ReviewsCounter,
    BuyBtn,
    WaitListBtn,
    AddToComparisonBtn,
    WishListBtn
  },
  props: {
    id: {
      type: Number,
      default: null
    },
    code: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    titleAnalytics: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: String,
      required: false,
      default: ''
    },
    secondImageUrl: {
      type: String,
      required: false,
      default: ''
    },
    rating: {
      type: String,
      default: ''
    },
    reviewsCount: {
      type: Number,
      default: null
    },
    price: {
      type: String,
      default: ''
    },
    isAvailable: {
      type: Boolean,
      default: false
    },
    isNovelty: {
      type: Boolean,
      defaultL: false
    },
    isPreorder: {
      type: Boolean,
      default: false
    },
    isArchive: {
      type: Boolean,
      default: false
    },
    isInWaitList: {
      type: Boolean,
      default: false
    },
    isInWishList: {
      type: Boolean,
      default: false
    },
    availableInStore: [Boolean, Object],
    inStock: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['isManager']),
    ...mapState({
      config: state => state.init.config,
      analyticsData: state => state.productInfo.productInfo.analyticsData,
      allegroLink: state => state.productInfo.productInfo.allegroLink
    }),
    priceObject: function () {
      return JSON.parse(this.price)
    },
    getNewPrice () {
      return +this.priceObject.price_new ?? null
    },
    getOldPrice () {
      return this.priceObject.price_old && this.priceObject.price_old !== this.priceObject.price_new
        ? +this.priceObject.price_old
        : null
    },
    showProductPrice () {
      return (this.isAvailable && this.getNewPrice) || (this.availableInStore && this.getNewPrice) || (this.isPreorder && this.getNewPrice)
    }
  },
  methods: {
    async handleAllegroRedirect (e, link) {
      e.preventDefault()
      if (GoogleEnhancedEcommerce.isEnabled) {
        await GoogleEnhancedEcommerce.buyInAllegro()
      }
      window.open(link, '_blank', 'noopener, noreferrer')
    }
  }
}
</script>

<style scoped lang="sass">

.product-card-product-page
  position: relative
  padding: 20px
  border: 1px solid $nd-border-color
  border-radius: 3px

.product-card-product-page__info-wrap
  display: flex
  flex-direction: row
  margin-bottom: 40px

.product-card-product-page__photo
  max-width: 120px

.product-card-product-page__info
  width: 100%
  margin-left: 20px

.product-card-product-page__reviews-wrap,
.product-card-product-page__reviews
  display: flex
  align-items: center

.product-card-product-page__reviews-wrap
  flex-flow: row wrap
  justify-content: space-between

.product-card-product-page__reviews-wrap
  margin-bottom: 30px

.product-card-product-page__reviews
  align-items: baseline

.product-card-product-page__rating
  margin-right: 10px

.product-card-product-page__price
  +mmax(1366)
    display: flex
    flex-direction: column-reverse

.product-card-product-page__price--not-available
  color: $placeholder-color
  font-weight: 500
  font-size: 16px
  line-height: 19px

  +mmin($tablet)
    font-size: 18px
    line-height: 21px

.product-card-product-page__button-wrap
  display: flex
  flex-flow: row wrap
  align-items: center
  margin-top: auto
  justify-content: space-between
  position: relative

.product-card-product-page__buy-btn-wrap
  display: flex
  justify-content: space-between
  flex-flow: row wrap
  width: 100%

.product-card-product-page__buy-btn
  width: 48%

  +mmax(1366)
    width: 100%

  &--novelty
    width: 100%

  &--available-in-store
    width: 100%

.wait-list--card
  width: 100%

.product-card-product-page__one-click-btn
  width: 48%

  +mmax(1366)
    margin-top: 20px
    width: 100%

.wish-list-btn__text
  display: block

.product-card-product-page__price
  margin: 30px 0 0

.product-card-product-page__add-to-comparison,
.product-card-product-page__wish-list-btn
  margin-top: 20px
  width: 48%

  +mmax(1366)
    width: 100%

.product-card-product-page__wish-list-btn
  margin-left: 0
.allegro-btn
  color: #333
  width: 48%
  font-size: 14px
  line-height: 1.25
  padding: 7.5px 20px
  display: inline-flex
  border-radius: 3px
  border: 1px solid #FF2F00
  background-color: #fff
  align-items: center
  white-space: nowrap
  box-shadow: 0 0 0 #FF2F00
  justify-content: center
  transition: box-shadow 0.2s
  &:hover
    box-shadow: 0 0 3px #FF2F00
  +mmax(1366)
    width: 100%
    margin-top: 20px
    justify-content: center
  +mmax($tablet--hor)
    width: 48%
    justify-content: center
  +mmax($tablet)
    padding: 9.5px
  svg
    margin-left: 5px
</style>
